import { ApiPatientBalanceResponse } from 'src/app/core/models';

export const makePayment = () => ({});

export const getPatientBalance = (): ApiPatientBalanceResponse => {
  return {
    balance: 42.42,
  };
};
